// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"de65ff90","239":"4ac6c288","455":"47f043d5"}[chunkId] + ".chunk.js";
};